module.exports = __webpack_public_path__ + "img/check.6f134a5e.svg";